export const HANDLE_TICKET_AREA = "HANDLE_TICKET_AREA";
export const HANDLE_FILTER_AREA = "HANDLE_FILTER_AREA";

export const GET_TICKET_LIST = "GET_TICKET_LIST";
export const GET_TICKET_LIST_SUCCESS = "GET_TICKET_LIST_SUCCESS";
export const GET_TICKET_LIST_ERROR = "GET_TICKET_LIST_ERROR";

export const GET_TICKET_FORMS = "GET_TICKET_FORMS";
export const GET_TICKET_FORMS_SUCCESS = "GET_TICKET_FORMS_SUCCESS";
export const GET_TICKET_FORMS_ERROR = "GET_TICKET_FORMS_ERROR";

export const SET_TICKET_FILTER = "SET_TICKET_FILTER";
export const RESET_TICKET_FILTER = "RESET_TICKET_FILTER";

export const NEXT_TICKET_PAGE = "NEXT_TICKET_PAGE";
export const PREV_TICKET_PAGE = "PREV_TICKET_PAGE";
export const SET_TICKET_PAGE = "SET_TICKET_PAGE";

export const SET_TICKET_SORT = "SET_TICKET_SORT";
export const RESET_TICKET_SORT = "RESET_TICKET_SORT";
